export const TOAST_CONST = {
  saveSuccess: {
    title: '성공',
    description: '성공적으로 저장되었습니다.',
  },
  deleteSuccess: {
    title: '성공',
    description: '성공적으로 삭제되었습니다.',
  },
  rejectSuccess: {
    title: '성공',
    description: '성공적으로 반려 처리되었습니다.',
  },
  error: {
    title: '실패',
  },
};
